module.exports = __webpack_public_path__ + "img/students.5ee88bac.jpeg";